module.exports = __webpack_public_path__ + "img/ChatBot.9b264d9e.svg";